import React, { useEffect, useState } from "react";
import { postCrearProcedimiento, postProcedimientoModificar, postProcedimientoVias } from "../../../services/PaginaRuta";
import ModalAgregarListaSeleccionEspecialidad from "./ModalAgregarListaSeleccionEspecialidad";
import ModalAgregarSeleccionHonorariosCirujano from "./ModalAgregarSeleccionHonorariosCirujano";
import ModalListaSeleccionMaestroProcedimientos from "./ModalListaSeleccionMaestroProcedimientos";
import ModalMedicoAgregarProcedimiento from "./ModalMedicoAgregarProcedimiento";

const ModalAgregarProcedimientoDeCirugia = ({
  setmodalOnAgregarProcedimientoCirugia,
  idCirugia,
  passActualizarTablaProcedimiento,
  user
}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [dataAutoriza, setdataAutoriza]=useState('')
  const [isAutoriza,setisAutoriza]=useState(false)
  const [modalOnListaSeleccionMaestro, setmodalOnListaSeleccionMaestro]=useState(false);
  const [modalOnMedico, setmodalOnMedico]=useState(false)
  const [modalOnEspecialidad, setmodalOnEspecialidad]=useState(false)  
  const [dataUser, setDataUser] = useState([])
  const [seleccionarProcedimientoError, setseleccionarProcedimientoError]=useState('')
  const [cantidadError, setcantidadError] = useState('')
  const [viaError, setViaError]=useState('')
  const [medicoError, setmedicoError]=useState('')
  const [especialidadError, setespecialidadError]=useState('')
  const [honorarioError, sethonorarioError]=useState('')
  const [via, setVia]=useState('')
  const [dataVias,setdataVias]=useState([])
  const [modalOnAgregarSeleccionHonorariosCirujano, setmodalOnAgregarSeleccionHonorariosCirujano]= useState(false)
  const [dataChildAgregarProcedimiento, setdataChildAgregarProcedimiento]=useState({
    codigoProcedimiento:'',
    nombreProcedimiento:''
  })  

  const [dataChildAgregarMedico, setdataChildAgregarMedico]=useState({
    codigoMedico:'',
    nombreMedico:'',
    codigoEspecialidad:'',
    nombreEspecialidad:''
  })

  const [dataChildAgregarEspecialidad, setdataChildAgregarEspecialidad]=useState({
    codigoEspecialidad:'',
    nombreEspecialidad:''
  })

  const [dataChildAgregarHonorarios, setdataChildAgregarHonorarios]=useState({
    HnrCod:'',
    HnrDsc:''
  })

  const passDataAgregarHonorarios=(data)=>{
    setdataChildAgregarHonorarios(data)
    sethonorarioError('')
  }

  const passAgregarEspecialidad=(data)=>{
    //setdataChildAgregarEspecialidad(data)
    setdataChildAgregarMedico({
      codigoMedico: dataChildAgregarMedico.codigoMedico,
      nombreMedico: dataChildAgregarMedico.nombreMedico,
      codigoEspecialidad:data.codigoEspecialidad,
      nombreEspecialidad:data.nombreEspecialidad
    })
    if(data){
      setespecialidadError('')
    }    
  }

  const passAgregarMedico=(data)=>{
    setdataChildAgregarMedico(data)
    if(data){
      setmedicoError('')
      setespecialidadError('')
    }    
    setdataChildAgregarEspecialidad({
      codigoEspecialidad:'',
      nombreEspecialidad:''
    })
    
  }

  const passAgregarProcedimiento=(data)=>{
    setdataChildAgregarProcedimiento(data)
    if(data){
      setseleccionarProcedimientoError('')
    }
  }

  const handleOnClickAgregarSeleccionHonorariosCirujano = ()=>{
    setmodalOnAgregarSeleccionHonorariosCirujano(true)
  }

  const handleClickEspecialidad=()=>{
    setmodalOnEspecialidad(true)
  }

  const handleOnclickMedico =()=>{
    setmodalOnMedico(true)
  }

  const handleCancelarClick = () => {
    setmodalOnAgregarProcedimientoCirugia(false);
  };

  const handleOnchangeListaSeleccionMaestro = () => {
    setmodalOnListaSeleccionMaestro(true);
  };

  

  const handleOnsubmitCrearProcedimiento=(e)=>{
    e.preventDefault();
    const bodyCrear={
      ProEmpCod:usuarioInfo.Empresa,
      ProMCDpto:usuarioInfo.Sede,
      ProCirCod: idCirugia,
      CrgCod: e.target.codigoProcedimiento.value,
      CrgPrcCns:'1',
      CrgEst:'S',     //Indic si se realiz􀀁 el proced.
      CrgCnt: e.target.cantidadProcedimiento.value,
      ViaCod: e.target.via.value,
      DesQx:'',       //Descripci􀀁n Quirurgica
      MedCod: e.target.codigoMedico.value,
      EspcCod: `${e.target.codigoEspecialidad.value}`,
      CrgHnrCi:dataChildAgregarHonorarios.HnrCod, //Honorario de Cirujano
      CRGPRCAUT:dataAutoriza,
      CirFinCod:'',  //Finalidad del servicio
      DiligencioDesQx:'No'
    }
    //CRGPRCAUT:'N o S',
    //CrgHnrCi:'codigo honorario'
    console.log(bodyCrear,'body  Crear')

    if(seleccionarProcedimientoError=='' && cantidadError=='' && viaError=='' && medicoError=='' && especialidadError=='' && honorarioError==''){      
      postCrearProcedimiento(bodyCrear).then((res)=>{
        //console.log(res.data,'guardadooo')
        passActualizarTablaProcedimiento(bodyCrear)
        setmodalOnAgregarProcedimientoCirugia(false)
      }).catch((error) => {
        //console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true);
        //setLoading(true);
      });
      
      
      
    }else{
      console.log('error')
    }
  }

  

  useEffect(()=>{
    setdataAutoriza('N')
    //setViaError('Seleccionar una vía')
    setmedicoError('Seleccionar Médico')
    setespecialidadError('Seleccionar especialidad')
    sethonorarioError('Seleccionar Honorario')
    const bodyDatosUser = {
      vaProEmpCod: usuarioInfo.Empresa,
      varProMCDpto: usuarioInfo.Sede,
      varProCirCod: idCirugia,
    };

    postProcedimientoModificar(bodyDatosUser).then((res)=>{
      setDataUser(res.data[0])
      //console.log(res.data,"datos usuario")
    })

    setseleccionarProcedimientoError('Seleccionar un procedimiento')
    setcantidadError('Digite una cantidad')
    postProcedimientoVias().then((res)=>setdataVias(res.data))
  },[])

  //////OnChange/////
  const handleOnchangeCantidad=(e)=>{
    let dataCantidad = e.target.value    
    if(dataCantidad){
      setcantidadError('')
    }else{
      setcantidadError('Digite una cantidad')
    }
  }

  const handleOnchangeProcedimiento=(e)=>{
    let dataProcedimiento = e.target.value
    //console.log(dataChildAgregarProcedimiento.codigoProcedimiento,'dataChildAgregarProcedimiento.codigoProcedimiento')
    if(dataProcedimiento){
      setseleccionarProcedimientoError('')
      setdataChildAgregarProcedimiento({
        codigoProcedimiento:dataChildAgregarProcedimiento.codigoProcedimiento,
        nombreProcedimiento:dataChildAgregarProcedimiento.nombreProcedimiento
      })
    }
    // else if(dataChildAgregarProcedimiento.codigoProcedimiento){
    //   setseleccionarProcedimientoError('')
    // }
    else {
      setseleccionarProcedimientoError('Seleccionar un procedimiento')
    }
  }

  const handleOnchangeVia=(e)=>{
    //console.log(e.target.value,'viaa')
    setVia(e.target.value)
    // if(e.target.value == "01 "  || e.target.value == ''){
    //   setViaError('Seleccionar una vía')
    // }else{
      
    //   setViaError('')
    // }
    if(e.target.value == ''){
      setViaError('Seleccionar una vía')
    }else{
      
      setViaError('')
    }
  }

  const handleOnchangeAutoriza=()=>{
    setisAutoriza(!isAutoriza)
    //console.log(!isAutoriza,'!isAutoriza')
    if(!isAutoriza){
      setdataAutoriza('S')
    }else{
      setdataAutoriza('N')
    }
  }

  return (
    <>
      <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Procedimientos de Cirugía
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <div className="flex-auto overflow-y-auto relative px-2">
            <form onSubmit={handleOnsubmitCrearProcedimiento}>
              <div className="flex-auto overflow-y-auto relative px-2">
                
                  <div className="w-1/3 px-4">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Autorizada?
                    </label>
                    <input
                      checked={isAutoriza}
                      onChange={handleOnchangeAutoriza}
                      autoComplete="off"
                      className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                      type="checkbox"
                      name="valoracionPreanestesica"
                      id="flexCheckDefault"
                      
                    />
                  </div>
                  <div className="flex flex-row py-2  text-left">
                    <div className="w-1/5  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        N° Cirugía
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        defaultValue={dataUser.ProCirCod}
                        name='numeroCirugia'
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/5  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        N° Documento 
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        defaultValue={dataUser.MPCedu}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/5  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Tipo Documento
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        defaultValue={dataUser.MPTDoc}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-2/5  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Nombre del Paciente
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        defaultValue={dataUser.MPNOMC}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                
                <h5
                  className="text-xl font-medium leading-normal text-gray-800 text-center pt-2"
                  id="exampleModalScrollableLabel"
                >
                  Procedimientos
                </h5>
                <div className="flex text-left pt-5">
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Procedimiento
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      
                      name='codigoProcedimiento'
                      onChange={handleOnchangeProcedimiento}
                      onFocus={handleOnchangeListaSeleccionMaestro}
                      value={dataChildAgregarProcedimiento.codigoProcedimiento}
                      
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {seleccionarProcedimientoError}
                    </label>
                  </div>
                  <div className="w-3/4 px-1 pt-2">
                    <textarea
                      autoComplete="off"
                      disabled={true}
                      
                      defaultValue={dataChildAgregarProcedimiento.nombreProcedimiento}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-white bg-clip-padding border border-solid border-gray-300 rounded
                            transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      id="exampleFormControlTextarea1"
                      rows="2"
                      placeholder=""
                    ></textarea>
                  </div>
                </div>

                <div className="flex py-1 text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Cantidad
                    </label>
                    <input
                      autoComplete="off"
                      onChange={handleOnchangeCantidad}
                      type="number"
                      name="cantidadProcedimiento"
                     
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {cantidadError}
                    </label>
                  </div>
                  <div className="w-2/3  px-4">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Vía
                    </label>
                    <div className="">
                      
                      <select
                          value={via}
                          onChange={handleOnchangeVia}
                          name="via"
                          className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                          aria-label="Default select example"
                        >
                          {dataVias.map((item) => (
                            <option value={item.ViaCod} key={item.ViaCod}>
                              {item.ViaDsc}
                            </option>
                          ))}
                        </select>
                      <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {viaError}
                    </label>
                    </div>
                  </div>
                </div>
                <div className="flex py-1 text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Código Médico
                    </label>
                    <input
                      onFocus={handleOnclickMedico}
                      defaultValue={dataChildAgregarMedico.codigoMedico}
                      name='codigoMedico'
                      autoComplete="off"
                      type="text"
                      //defaultValue={dataDetalles.MedCod}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {medicoError}
                    </label>
                  </div>
                  <div className="w-2/3  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Médico
                    </label>
                    <input
                      autoComplete="off"
                      //defaultValue={dataDetalles.MedNom}
                      defaultValue={dataChildAgregarMedico.nombreMedico}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    
                  </div>
                </div>
                <div className="flex py-1 text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Código Especialidad
                    </label>
                    <input
                      onFocus={handleClickEspecialidad}
                      defaultValue={dataChildAgregarMedico.codigoEspecialidad}
                      autoComplete="off"
                      name="codigoEspecialidad"
                      
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {especialidadError}
                    </label>
                  </div>
                  <div className="w-2/3  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Especialidad
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      defaultValue={dataChildAgregarMedico.nombreEspecialidad}
                      //defaultValue={dataDetalles.EspcDes}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex py-1 text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Honorario
                    </label>
                    <input
                    defaultValue={dataChildAgregarHonorarios.HnrCod}
                      onFocus={handleOnClickAgregarSeleccionHonorariosCirujano}
                      autoComplete="off"
                      type="text"
                      //defaultValue={dataDetalles.CrgHnrCi}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {honorarioError}
                    </label>
                  </div>
                  <div className="w-2/3  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Honorario
                    </label>
                    <input
                    defaultValue={dataChildAgregarHonorarios.HnrDsc}
                      autoComplete="off"
                      type="text"
                      //defaultValue={dataDetalles.CrgHnCiD}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            
              <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                <button
                  type="button"
                  onClick={handleCancelarClick}
                  //disabled={true}
                  className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button type="submit"
                  //disabled={disabledGuardar}
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                  Guardar
                </button>
              </div>
            </form>
            </div>
          </div>
        </div>
      </div>
      {modalOnListaSeleccionMaestro ? (
        <ModalListaSeleccionMaestroProcedimientos
          setmodalOnListaSeleccionMaestro={setmodalOnListaSeleccionMaestro}
          passAgregarProcedimiento={passAgregarProcedimiento}
        />
      ) : null}
      {modalOnMedico? <ModalMedicoAgregarProcedimiento setmodalOnMedico={setmodalOnMedico} passAgregarMedico={passAgregarMedico}/>:null}
      {modalOnEspecialidad? <ModalAgregarListaSeleccionEspecialidad setmodalOnEspecialidad={setmodalOnEspecialidad} codigoMedicoEspecialista={dataChildAgregarMedico.codigoMedico} passAgregarEspecialidad={passAgregarEspecialidad}/>:null}
      {modalOnAgregarSeleccionHonorariosCirujano? <ModalAgregarSeleccionHonorariosCirujano setmodalOnAgregarSeleccionHonorariosCirujano={setmodalOnAgregarSeleccionHonorariosCirujano} passDataAgregarHonorarios={passDataAgregarHonorarios} user={user} dataChildAgregarProcedimiento={dataChildAgregarProcedimiento}/>:null}
    </>
     
  );
};

export default ModalAgregarProcedimientoDeCirugia;
